import { useContext, useMemo } from 'react';

import { AppContext } from '../context/app';
import {
  isGozioPlace,
  isLatLng,
  isSatellitePlace,
  isSearchAddressResult,
} from '../utils/typeGuards';
import { useKioskManager } from './useKioskManager';

export const useGetShareUrl = (email = false) => {
  const { kioskRegistration, kiosk } = useKioskManager();
  const { navDestinationPlace, navStartingPlace } = useContext(AppContext);

  const navUrl = useMemo(() => {
    let url = `${process.env.REACT_APP_WEBAPP_LINK}/campus-navigation?`;

    if (isGozioPlace(navStartingPlace) || isSatellitePlace(navStartingPlace)) {
      url = `${url}startingid=${navStartingPlace.id}`;
    } else if (isSearchAddressResult(navStartingPlace)) {
      url = `${url}startingAddress=${encodeURIComponent(navStartingPlace.address)}&startingLat=${navStartingPlace.geolocation.lat}&startingLon=${navStartingPlace.geolocation.lon}`;
    } else if (isLatLng(navStartingPlace)) {
      url = `${url}startingid=${navStartingPlace.lat},${navStartingPlace.lng}`;
    }

    if (kioskRegistration) {
      url = `${url}&kioskId=${kiosk?.id}`;
    }

    // Add destination
    url = `${url}&destinationid=${navDestinationPlace?.id}`;

    // If sharing via email, add print mode
    if (email) {
      url = `${url}&printMode=true`;
    }

    url = `${url}&fromQRcode=true`;

    return url;
  }, [
    email,
    kiosk?.id,
    kioskRegistration,
    navDestinationPlace?.id,
    navStartingPlace,
  ]);

  return navUrl;
};
